import { Injectable } from '@angular/core';

@Injectable()
export class IAscMasterAddedData {
    comboBox: string;
    valueForCombo: string;
    encounterId: string;
    ascMasterId: string;
    attributeId: number;
    attributeType: string;
    attributeName: string;
    attributeDesc: string;
    isActive: true;
    createdModifiedBy: string;

}

export class IAscType {
    comboBox: string; //AscType
    valueForCombo: string // AscName
    // encounterId:string;
}

export class ONCCMasterMeasure {
    Id: number;
    MeasureName: string;
    MeasureDesc: string;
    IsActive: boolean;
}
export class ONCCMasterMeasures {
    Id: number;
    measureName: string;
    measureDesc: string;
    IsActive: boolean;
    measureId: Number;
}

export class ONCCConfiguration {
    Id: number;
    ProviderId: string;
    LocationId: string;
    Tin: string;
    IsActive: boolean;
    CreatedBy: string;
    CreatedOn: Date;
    ProviderFullName: string;
    LocationNames: string;
    MeasureName: string;
}